module.exports = {
    "collapse": `Pienenn\xe4`,
    "expand": `Laajenna`
};


//# sourceMappingURL=fi-FI.main.js.map
